import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { Button, LinkTo } from '../../../helpers';

function UserDelete({ item, onDelete, organizationId }) {
  return (
    <div className="row">
      <div className="col-12">
        <div className="alert alert-danger">
          You are about to delete:&nbsp;
          <LinkTo href={`organizations/${organizationId}/users/${item.relationships.user_role.data.attributes.username}/show`}>{(get(item, 'relationships.user_role.data.attributes.username'))}</LinkTo>.&nbsp;
          Are you sure?
        </div>

        <div className="btn-group">
          <LinkTo button icon="times-circle" color="secondary" href={`organizations/${organizationId}/users`}>>
            Cancel
          </LinkTo>
          <Button button icon="trash" color="danger" href="users" onClick={() => onDelete(get(item, 'relationships.user_role.data.attributes.username'))}>
            Yes, Delete
          </Button>
        </div>
      </div>
    </div>
  );
}

UserDelete.propTypes = {
  item: PropTypes.shape({
    username: PropTypes.string
  }).isRequired,
  onDelete: PropTypes.func.isRequired
};

export default UserDelete;
